import { Button } from '@/components/ui/button';
import { ShoppingBag, MessageCircle } from 'lucide-react';
import { useAnalytics } from '@/hooks/useAnalytics';

interface BookingButtonProps {
  excursionTitle: string;
  whatsappCatalogId?: string;
  variant?: 'default' | 'outline' | 'secondary';
  size?: 'default' | 'sm' | 'lg';
  className?: string;
}

const WHATSAPP_CATALOG_URL = 'https://wa.me/c/5521976795050';

export const BookingButton = ({
  excursionTitle,
  whatsappCatalogId,
  variant = 'default',
  size = 'default',
  className = ''
}: BookingButtonProps) => {
  const { trackBookingIntent } = useAnalytics();

  const handleClick = () => {
    trackBookingIntent(excursionTitle, 'form');
    window.location.href = `/contact?excursion=${encodeURIComponent(excursionTitle)}`;
  };

  return (
    <Button 
      onClick={handleClick} 
      variant={variant} 
      size={size}
      className={`min-h-[44px] focus-visible-ring ${className}`}
      aria-label={`Réserver l'excursion ${excursionTitle}`}
    >
      <MessageCircle className="w-4 h-4 mr-2" aria-hidden="true" />
      <span>C'est parti !</span>
    </Button>
  );
};
